module.exports = __webpack_public_path__ + "static/img/20005 (4).963ff9e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20005 (4).webp
// module id = 4hVi
// module chunks = 14